import * as TYPE from '../../TYPE';
export var showLogic = TYPE.logic.makeTAddIsNotMoralOrIgnored({});
